import { PatientIdentityStatus } from '@/core/models/patient.model'
import { useIdentityStatus } from '@/entities/patient'
import { FeatureFlag, useIsFlagEnabled } from '@/hooks/useIsFlagEnabled'
import { selectDMPConnectTlsiConnectorId } from '@/redux/reducers/dmp-connect.reducer'
import { useAppSelector } from '@/redux/rootReducer'

export function useShowDMP(patientId?: string) {
  const isDmpConnectEnabled = useIsFlagEnabled(FeatureFlag.DmpConnect)
  const tlsiConnectorId = useAppSelector(selectDMPConnectTlsiConnectorId)
  const { identityStatus } = useIdentityStatus(patientId)

  return (
    isDmpConnectEnabled &&
    !!tlsiConnectorId &&
    (identityStatus === PatientIdentityStatus.RECOVERED || identityStatus === PatientIdentityStatus.QUALIFIED)
  )
}
